import useScope from "~/hooks/useScope/useScope"
import AppContent from "../AppContent"
import ScopeLogo from "../ScopeLogo"
import TitleLink from "../TitleLink/TitleLink"
import { SupportChat } from "./components/chat/chat"
import AdPortalFooter from "./components/footer"
import AdPortalNicheFooter from "./components/nicheSiteFooter"
import * as Styled from "./style"
import type * as Types from "./types"

const AdPortal: Types.AdPortalComponent = () => {
    const scope = useScope()
    
    return (
        <Styled.AdPortalWrapper>
            <SupportChat />
            <Styled.Wrapper>
                <Styled.BrandColorBanner 
                    color={scope.brandColor} 
                />
                <Styled.HeaderContainer>
                    <ScopeLogo />
                    <TitleLink />
                </Styled.HeaderContainer>
                <Styled.HeaderBanner />
                <AppContent />
                { (scope?.id  === "meraosterlen") ? 
                    <AdPortalNicheFooter />
                    :
                    <AdPortalFooter />
                }
            </Styled.Wrapper>
        </Styled.AdPortalWrapper>
    )
}

export default AdPortal